import axios from 'axios'
import epsClient, { getUrl } from 'enrollment-platform/api/eps.client'

// Same config and auth interceptor as the shared epsClient, with `basePath` baked into
// the baseURL. Mirrors how eps-v1.client.ts derives its client.
export function createEpsScopedClient(basePath: string) {
  const scopedClient = axios.create({
    ...epsClient.defaults,
    baseURL: `${getUrl()}${basePath}`,
  })

  epsClient.interceptors?.request?.['handlers']?.forEach(
    ({ fulfilled, rejected }) => {
      scopedClient.interceptors.request.use(fulfilled, rejected)
    }
  )
  epsClient.interceptors?.response?.['handlers']?.forEach(
    ({ fulfilled, rejected }) => {
      scopedClient.interceptors.response.use(fulfilled, rejected)
    }
  )

  return scopedClient
}
